// ./components/CopyButton.jsx
import { useState } from 'react';
import { motion } from 'framer-motion';
import { FaCopy, FaCheck } from 'react-icons/fa';
import './CopyButton.scss';

const CopyButton = ({ text, className }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <motion.button
      className={`copy-button ${className || ''} ${copied ? 'copied' : ''}`}
      onClick={handleCopy}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      initial={false}
    >
      <motion.span
        initial={{ opacity: 1 }}
        animate={{ opacity: copied ? 0 : 1 }}
        transition={{ duration: 0.2 }}
      >
        <FaCopy />
      </motion.span>
      <motion.span
        className="check-icon"
        initial={{ opacity: 0 }}
        animate={{ opacity: copied ? 1 : 0 }}
        transition={{ duration: 0.2 }}
      >
        <FaCheck />
      </motion.span>
    </motion.button>
  );
};

export default CopyButton;
